import React from 'react'
import styled from 'styled-components'
import Title from '../../components/Title'
import hecho from '../../assets/static/hecho.png'
import { useTranslation } from "react-i18next"


const About = () => {
  const { t } = useTranslation();

  return (
    <Main>
      <Container>
        <Img src={hecho} alt="hecho en mexico" />
        <Title size={'small'} color={'white'}>
          {t('home.about.intro')}
        </Title>
      </Container>
    </Main>
  )
}

export default About

const Main = styled.main`
  width: 100vw;
  display: grid;
  grid-template-columns: 1fr minmax(375px, 1200px) 1fr;
  background-color: ${({ theme }) => theme.secondary};
  position: relative;
  color: #fff;
`

const Container = styled.div`
  grid-column: 2/3;
  display: flex;
  padding: 75px 0;
  text-align: center;
  align-items: center;
  @media (max-width: 768px) {
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 50px 15px;
  }
`

const Img = styled.img`
 
  height: 150px;
  margin-right: 75px;
  @media (max-width: 768px) {
    height: 200px;
    margin: 0 0 25px 0;
  }
`
